import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCalendar, FiMonitor, FiUnlock, FiTrendingUp, FiArrowRight } = FiIcons;

const ProgramOverview = () => {
  const features = [
    { icon: FiCalendar, text: "21 días" },
    { icon: FiMonitor, text: "100% online" },
    { icon: FiUnlock, text: "Acceso ilimitado" },
    { icon: FiTrendingUp, text: "Aplicación Científica" }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-blue-600 to-purple-700 text-white">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto text-center"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-8">
            Descubre ESTRATEGIA M.E.T.A.: Tu Camino Hacia el Bienestar Integral
          </h2>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-8">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white/10 backdrop-blur-sm p-6 rounded-xl text-center"
              >
                <SafeIcon icon={feature.icon} className="text-3xl mb-3 mx-auto text-yellow-300" />
                <p className="font-semibold">{feature.text}</p>
              </motion.div>
            ))}
          </div>
          
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="bg-yellow-400 text-blue-900 px-8 py-4 rounded-full font-bold text-lg hover:bg-yellow-300 transition-colors flex items-center gap-2 mx-auto shadow-lg"
          >
            ¡Empieza ahora! Asegura tu cupo
            <SafeIcon icon={FiArrowRight} className="text-xl" />
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};

export default ProgramOverview;